/* American Premium reader PDP design (every AP product page, see snippet ap-reader-pdp; loaded after ap-pdp-page.js).
   1. Links into closed disclosures: "Explore benefits", the section navigation and a page loaded with a hash open
      the native <details> that holds the target (#all-benefits, #comparison) before the browser scrolls to it.
   2. Gallery and ingredient panels switch in 220 ms instead of the shared 340/360 ms.
   Without this file every disclosure still opens with its summary, and every study link is a plain link. */
(() => {
  'use strict';
  if (!document.body.classList.contains('ap-reader-pdp')) return;

  const gallery = document.querySelector('.pdp-gallery');
  if (gallery) {
    const stage = gallery.querySelector('.gallery-stage');
    // Keep tall panels readable above the fixed purchase and Shopify preview bars.
    const placeGallery = () => {
      if (innerWidth < 900) {
        gallery.style.removeProperty('--gallery-height');
        gallery.style.removeProperty('--gallery-controls-height');
        return;
      }
      if (stage) gallery.style.setProperty('--gallery-controls-height', `${gallery.offsetHeight - stage.offsetHeight}px`);
      gallery.style.setProperty('--gallery-height', `${gallery.offsetHeight}px`);
    };
    new ResizeObserver(placeGallery).observe(gallery);
    addEventListener('resize', placeGallery, {passive: true});
    placeGallery();
  }

  // Open the details that is, contains (data-reader-disclosure) or wraps the target. Returns the target when anything opened.
  function reveal(hash) {
    let target = null;
    try { target = hash && hash.length > 1 ? document.getElementById(decodeURIComponent(hash.slice(1))) : null; } catch (_) {}
    if (!target) return null;
    let opened = false;
    const open = d => { if (d && !d.open) { d.open = true; opened = true; } };
    if (target instanceof HTMLDetailsElement) open(target);
    target.querySelectorAll(':scope [data-reader-disclosure]').forEach(open);
    for (let d = target.parentElement && target.parentElement.closest('details'); d; d = d.parentElement && d.parentElement.closest('details')) open(d);
    return opened ? target : null;
  }

  // Capture phase, so the disclosure is open before ap-pdp-page.js (Explore benefits) or the browser scrolls.
  document.addEventListener('click', e => {
    const link = e.target.closest && e.target.closest('a[href^="#"]');
    if (link && link.hash) reveal(link.hash);
  }, true);
  addEventListener('hashchange', () => { const t = reveal(location.hash); if (t) t.scrollIntoView({block: 'start'}); });
  if (location.hash) {
    const t = reveal(location.hash);
    if (t) requestAnimationFrame(() => t.scrollIntoView({block: 'start'}));
  }

  // Quicker panel changes: shorten the shared tab animations once they have started.
  const shorten = selector => () => queueMicrotask(() => document.querySelectorAll(selector).forEach(panel =>
    panel.getAnimations().forEach(a => a.effect && a.effect.updateTiming({duration: 220}))));
  [['.gallery-tabs', '.gallery-panel'], ['.ingredient-tabs', '.ingredient-panel']].forEach(([tabs, panels]) => {
    const list = document.querySelector(tabs);
    if (!list) return;
    list.addEventListener('click', shorten(panels));
    list.addEventListener('keydown', shorten(panels));
  });
})();
